import { JSX } from 'react';
import CalendarPickerItem from './calendarPickerItem';
import { CalendarId, CALENDAR_IDS } from '../../services/calendarService';
import './calendarPicker.css';

interface CalendarPickerProps {
    selectedCalendar: CalendarId[];
    onCalendarSelect: (calendarId: CalendarId[]) => void;
}

const CalendarPicker = ({ selectedCalendar, onCalendarSelect }: CalendarPickerProps): JSX.Element => {

    const handleCalendarSelect = (calendarId: CalendarId) => {
        if (selectedCalendar.includes(calendarId)) {
            onCalendarSelect(selectedCalendar.filter((id) => id !== calendarId));
        } else {
            onCalendarSelect([...selectedCalendar, calendarId]);
        }
    }

    return (
        <div className='calendar-picker'>
            {CALENDAR_IDS.map((calendarId) => (
                <CalendarPickerItem selected={selectedCalendar.includes(calendarId)} onSelectedChange={() => handleCalendarSelect(calendarId)} calendarId={calendarId}/>
            ))}
        </div>
    );
};

export default CalendarPicker;
